import { createTheme, ThemeProvider } from "@mui/material";
import { PropsWithChildren, useMemo } from "react";
import { useConfigurationContext } from "@/features/configuration/contexts/configuration-context";
import usePrintBold from "@/features/configuration/hooks/use-print-bold";

export default function FacturaThemeProvider({
    children
}: PropsWithChildren) {
    const { printFont, printFontSize } = useConfigurationContext();
    const [printBold] = usePrintBold();

    const theme = useMemo(() => createTheme({
        shape: {
            borderRadius: 0
        },
        palette: {
            action: {
                hover: "rgba(0, 0, 0, 0)"
            },
            text: {
                primary: "black",
                secondary: "black",
                disabled: "black"
            }
        },
        components: {
            MuiPaper: {
                styleOverrides: {
                    root: {
                        borderWidth: "0px"
                    }
                }
            },
            MuiTable: {
                styleOverrides: {
                    root: {
                        overflow: "hidden"
                    }
                }
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        borderWidth: "0px",
                        paddingTop: "3px",
                        paddingBottom: "3px",
                    },
                    head: {
                        fontWeight: printBold ? 700 : "normal",
                        WebkitTextStroke: printBold ? "0.5px black" : undefined
                    }
                }
            }
        },
        typography: {
            allVariants: {
                fontFamily: printFont || `"JetBrains Mono", monospace`,
                fontSize: printFontSize ? `${printFontSize}pt` : "8pt",
                fontWeight: printBold ? 700 : "normal",
                WebkitTextStroke: printBold ? "0.5px black" : undefined
            }
        }
    }), [printFont, printFontSize, printBold]);

    return <ThemeProvider theme={theme}>
        {children}
    </ThemeProvider>
}